"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useLocalisation;
function useLocalisation() {
    return window.localisation;
}


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/lingui-cdn/lib/i18n/use-localisation.js
// module id = M3sL
// module chunks = 0